import './TracksMenu.scss';
import { jsxs, jsx } from 'react/jsx-runtime';

/* External */

function TracksMenu(_ref) {
  var title = _ref.title,
    tracks = _ref.tracks,
    onSelectTrack = _ref.onSelectTrack,
    getLanguageLabel = _ref.getLanguageLabel;
  return /*#__PURE__*/jsxs("ul", {
    className: "dtv-common-c-tracks-menu",
    role: "menu",
    children: [title && /*#__PURE__*/jsx("li", {
      className: "dtv-common-c-tracks-menu__title",
      tabIndex: "-1",
      children: title
    }), tracks.map(function (track) {
      var id = track.id,
        isSelected = track.isSelected;
      var elementItemClassName = 'dtv-common-c-tracks-menu__item';
      return /*#__PURE__*/jsx("li", {
        className: "".concat(elementItemClassName, " ").concat(isSelected ? "".concat(elementItemClassName, "--selected") : ''),
        children: /*#__PURE__*/jsx("div", {
          className: "dtv-common-c-tracks-menu__interactive-item",
          tabIndex: "-1",
          role: "menuitemradio",
          "aria-checked": isSelected,
          onClick: function onClick(event) {
            event.stopPropagation();
            onSelectTrack(track);
          },
          onKeyDown: function onKeyDown() {},
          children: getLanguageLabel(track)
        })
      }, id || '0');
    })]
  });
}
TracksMenu.defaultProps = {
  title: '',
  tracks: [],
  onSelectTrack: function onSelectTrack() {},
  getLanguageLabel: function getLanguageLabel() {}
};

export { TracksMenu as default };
//# sourceMappingURL=TracksMenu.js.map
